module.exports = __webpack_public_path__ + "img/collect.caa04894.svg";